export const CAMPAIGN_CREATE_URL = `${import.meta.env.VITE_CONFIGURATOR_URL}/campaigns/create`;

/**
 * Poll interval (ms) used to refresh a campaign while it is in the transient
 * `pending` state (launched, but the send has not been confirmed yet), so the
 * overview and list pages flip to `active` on their own once the send fires.
 */
export const CAMPAIGN_PENDING_POLL_MS = 5000;
